export const environment = {
  production: false,
  web3formsAccessKey: '237b0353-f6f6-4e4f-827c-cf85cdd4c510',
  web3formsEnableHCaptcha: true,
  backendBaseUrl: 'http://localhost:3000',
  calendlyUrl: 'https://calendly.com/contactogd-grupodingo/analisis-grupo-dingo',
};

